import { useMemo } from 'react';
import { TaskScheduleValue } from './CalendarSchedulerTypes';
import {
  browserTimezone,
  describeSchedule,
  formatRunDate,
  hasScheduleSlots,
  nextRunDates,
} from '../utils/calendarSchedule';
import './CalendarScheduler.css';

type ScheduleSummaryProps = {
  schedule: TaskScheduleValue;
  startDate?: string;
  endDate?: string;
};

function ScheduleSummary({ schedule, startDate, endDate }: ScheduleSummaryProps) {
  const runs = useMemo(
    () => nextRunDates(schedule, 3, startDate, endDate),
    [schedule, startDate, endDate],
  );

  if (!hasScheduleSlots(schedule)) return null;

  return (
    <div className="cs-summary">
      <div className="cs-summary-head">
        <div className="cs-summary-title">{describeSchedule(schedule)}</div>
        <span className="cs-summary-tz">{browserTimezone()}</span>
      </div>
      <div className="cs-summary-runs">
        {runs.length
          ? `Next runs: ${runs.map(formatRunDate).join(' · ')}`
          : 'No upcoming runs in the selected date range'}
      </div>
    </div>
  );
}

export default ScheduleSummary;
